// extracted by mini-css-extract-plugin
export default {"paginationGroup":"Pagination_paginationGroup__mXsrA","paginationElement":"Pagination_paginationElement__dyHaz","paginationButton":"Pagination_paginationButton__b5Tc6"};